const hePlatforms = require('./platforms');

/**
 * INFRA SHARED VALUES
 */
module.exports = {
  hePlatforms,
};
